import { Add as AddIcon } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import NoComponentImage from 'src/assets/images/NoComponent.svg?react';
import { PATHS } from 'src/constants/paths';

import { EmptyComponentsProps } from './EmptyComponents.interface';
import { Header, ImageContainer, Wrapper } from './EmptyComponents.styled';

export const EmptyComponents = (props: EmptyComponentsProps) => {
  const navigate = useNavigate();

  return (
    <>
      <Wrapper>
        <ImageContainer>
          <NoComponentImage />
        </ImageContainer>
        <Header variant="h3">{props.message}</Header>

        {props.showButton ? (
          <Button
            variant="contained"
            size="small"
            onClick={() => {
              navigate(PATHS.COMPONENT_ADD);
            }}
            startIcon={<AddIcon />}>
            New component
          </Button>
        ) : null}
      </Wrapper>
    </>
  );
};
